import { render, staticRenderFns } from "./AccountSettingsSecurity.vue?vue&type=template&id=2c5ced1c&scoped=true"
import script from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsSecurity.vue?vue&type=style&index=0&id=2c5ced1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ced1c",
  null
  
)

export default component.exports